/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ProfileDetailData} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const API_DOMAIN = ENV().REACT_APP_DOMAIN
const initialState: any = {
  staffAccountList: [],
}

/////////////////////////superAdmin////////////////////////////////////

export const CreateStaffAccount: any = createAsyncThunk(
  '/CreateStaffAccount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/createStaff`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllStaff(data?.filter))

    return response.data
  }
)

export const GetAllStaff: any = createAsyncThunk(
  '/GetAllStaff',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}admin/getStafflist`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateStaffAccount: any = createAsyncThunk(
  '/UpdateStaffAccount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(`${API_URL}admin/updateStaff/${data?._id}`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllStaff({role: 'staffAdmin'}))
    thunkApi.dispatch(ProfileDetailData(data?._id))

    return response.data
  }
)

export const DeleteStaffAccount: any = createAsyncThunk(
  '/CreateStaffAccount',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/deleteStaffAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllStaff({page: data.page}))

    return response.data
  }
)

/////////////////////////////////////Staff--Account///////////////////////////
export const createdByStaffAccount: any = createAsyncThunk(
  '/createdByStaffAccount',
  async (data, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/createStaffByStaffAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllStaffForStaffAdmin())

    return response.data
  }
)

export const GetAllStaffForStaffAdmin: any = createAsyncThunk(
  '/GetAllStaffForStaffAdmin',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}admin/getStafflistByStaffAdmin`, {
      params: {...data},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateStaffAccountByStaffAdmin: any = createAsyncThunk(
  '/UpdateStaffAccountByStaffAdmin',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(
      `${API_URL}admin/updateStaffByStaffAdmin/${data?._id}`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllStaffForStaffAdmin())

    return response.data
  }
)

///////////////////// EXPORT ACCOUNT//////////////////////////////////

export const ExportStaffAccountList: any = createAsyncThunk(
  '/ExportStaffAccountList',
  async (data: any, thunkApi: any) => {
    const response: any = await axios
      .get(`${API_URL}admin/getstafflist`, {
        params: {...data.page, export: true, exportArr: data.checkList?.join(',')},
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self'))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

////////////////////////////User account///////////////////////////////

export const UpdateStatusStaff: any = createAsyncThunk(
  '/updateStatusStaff',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetAllStaff({page: data.page}))
    thunkApi.dispatch(ProfileDetailData(data?.data?.userId))

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }

    return response.data
  }
)

const StaffAccount = createSlice({
  name: 'staffAccount',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [CreateStaffAccount.pending]: (state) => {
      // return {...state,loading:true}
    },
    [CreateStaffAccount.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
    },
    [CreateStaffAccount.rejected]: (state, action) => {
      // toast.error(payload.error.email)
    },
    [GetAllStaff.fulfilled]: (state, {payload}) => {
      return {...state, staffAccountList: payload.data}
      // return {...state, staffAccList: payload.data,loading:true}
    },
    ///////////////////Staff Admin///////////////////////////////////////////////////////////////////////////////

    [createdByStaffAccount.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
    },
    [GetAllStaffForStaffAdmin.fulfilled]: (state, {payload}) => {
      return {...state, staffAccountList: payload.data}
    },
  },
})

export default StaffAccount.reducer
